import { useDispatch, useSelector } from 'react-redux';

import { resetParams, pushParams } from 'dpl/actions/query_params';
import { FILTER_PARAMS } from 'dpl/puppy_search_results/utils/constants';
import { FILTERS_MODAL, PAGE } from 'dpl/constants/query_params';

export default function useSearchFiltering() {
  const dispatch = useDispatch();
  const queryParams = useSelector(state => state.queryParams);
  const hasFilters = Object.keys(queryParams).some(qp =>
    FILTER_PARAMS.includes(qp)
  );

  function clearFilters() {
    dispatch(resetParams(PAGE, ...FILTER_PARAMS, { hash: true }));
  }

  const isFiltersModalOpen = queryParams[FILTERS_MODAL] === 'true';

  function toggleFilters() {
    dispatch(
      pushParams({ [FILTERS_MODAL]: !isFiltersModalOpen }, { hash: true })
    );
  }

  return {
    clearFilters,
    hasFilters,
    isFiltersModalOpen,
    toggleFilters
  };
}
